import React from 'react'
import AddToCalendarContent from './AddToCalendarContent'
import { ContentModal } from 'ui/acro'
// import './AddToCalendarModal.scss'

const AddToCalendarModal = ({ classDetails, useModal }) => {
  return (
    <ContentModal
      style={{ maxHeight: 'unset', maxWidth: '650px', width: '80%' }}
      useModal={useModal}
      overflow='hidden'
    >
      <AddToCalendarContent classDetails={classDetails} />
    </ContentModal>
  )
}

export default AddToCalendarModal
